function formatBytesToMB(bytes) {
	var marker = 1024 // Change to 1000 if required
	var decimal = 2 // Change as required
	var kiloBytes = marker // One Kilobyte is 1024 bytes
	var megaBytes = marker * marker // One MB is 1024 KB
	var gigaBytes = marker * marker * marker // One GB is 1024 MB
	var teraBytes = marker * marker * marker * marker // One TB is 1024 GB

	return (bytes / megaBytes).toFixed(decimal) + ' MB'
}

const inputText = $('.input--file label').text()

$('input[type="file"]').on('change', function () {
	var files = $(this).prop('files')
	var fieldset = $(this).parent()
	var sizeSum = ''
	var notAllowedFiles = []

	const allowedTypes = ['image/png', 'application/pdf', 'image/jpeg']

	$('.files', fieldset).html('')

	$.each(files, function (index, value) {
		if (!allowedTypes.includes(value.type)) {
			notAllowedFiles.push(value.name)
		}
		$('.files', fieldset).append('<span>' + value.name + ' (' + formatBytesToMB(value.size, 1) + ')</span>')
		sizeSum += value.size
	})

	if (notAllowedFiles.length > 0) {
		alert('Der Dateityp folgender Datei(en) ist nicht zulässig: ' + notAllowedFiles)
	}

	//$('.input--file__size').html(formatBytesToMB(sizeSum));

	if (files.length > 0) {
		if (files.length == 1) {
			var datei = 'Datei'
		} else {
			var datei = 'Dateien'
		}
		$('label', fieldset).text(files.length + ' ' + datei + ' ausgewählt')
	} else {
		$('label', fieldset).text(inputText)
	}
})
